import { forwardRef } from "react";
import { StyledIconBox } from "./IconBox.style.js";
import type { IconBoxProps } from "./IconBox.types.js";

export const IconBox = forwardRef<HTMLDivElement, IconBoxProps>(({ backgroundColor, padding, shape = "square", children, ...rest }, ref) => (
    <StyledIconBox backgroundColor={backgroundColor} padding={padding} shape={shape} ref={ref} {...rest}>
        {children}
    </StyledIconBox>
));
